document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".coffee-mobile-slider");

    if (!slider) return;

    let coffeeSwiper = null;

    function initSwiper() {
        if (window.innerWidth <= 989) {
            if (!coffeeSwiper) {
                coffeeSwiper = new Swiper(slider, {
                    slidesPerView: 1.15,
                    spaceBetween: 0,
                    centeredSlides: false,
                    speed: 600,

                    breakpoints: {
                        480: {
                            slidesPerView: 1.2,
                            spaceBetween: 0,

                        },

                        640: {
                            slidesPerView: 1.4,
                            spaceBetween: 0,

                        },

                        768: {
                            slidesPerView: 1.7,
                            spaceBetween: 0,
                        },
                    },
                });
            }
        } else {
            if (coffeeSwiper) {
                coffeeSwiper.destroy(true, true);
                coffeeSwiper = null;
            }
        }
    }

    initSwiper();

    window.addEventListener("resize", initSwiper);
});